import { Expose } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export enum ScratchGameStatus {
    Win = "WIN",
    Lose = "LOSE",
}

export class ScratchGameResult extends BaseModel {
    @Expose()
    id = 0;
    @Expose()
    result: ScratchGameStatus = ScratchGameStatus.Lose;
    @Expose()
    url = "";
}
